(function (upp) {
    'use strict';

    upp.factory('order', ['product',
        function (Product) {
            var _forEach = angular.forEach,
                _equals = angular.equals,
                _copy = angular.copy;

            function Order() {
                this.id = undefined;
                this.products = [];
                this.currency = undefined;
                this.price = undefined;
                this.shippingAddress = undefined;
                this.billingAddress = undefined;
                this.observations = undefined;
                this.unavailable = undefined;
                this.shippingCharges = undefined;
                this.redsys = false;
                this.payPal = false;
                this.refund = false;
                this.pickAtStore = false;
                this.pickAtStoreOption = undefined;
                this.wireTransfer = false;
                this.paymentModel = undefined;
                this.freeShippingCharges = false;
                this.allowsShipping = true;
                this.minimumOrder = undefined;
            }

            Order.prototype.initCurrency = function (currency) {
                if (!this.currency) {
                    if (currency) {
                        this.currency = currency;
                    } else {
                        throw new Error("No currency");
                    }
                }
            };

            Order.prototype.getProductsToCheckStock = function () {
                var self = this,
                    promos,
                    order = [];

                //for each product
                _forEach(self.products, function (product) {
                    promos = [];

                    //for each promotion in product
                    _forEach(product.promotions, function (promo) {
                        promos.push(promo.id);
                    });

                    order.push({
                        idProduct: product.id,
                        promotions: promos,
                        idAttribute: product.selectedVariation.id,
                        number: product.selectedStock
                    });
                });

                return order;
            };

            Order.prototype.getSelectedStock = function () {
                var self = this,
                    amount = 0;

                _forEach.call(self, self.products, function (product) {
                    amount += product.selectedStock;
                });

                return amount;
            };

            Order.prototype.findProductById = function (productId) {
                return this.products.find(function(product) {
                    return product.id === productId;
                });
            };

            Order.prototype.findProductByAttributeId = function (attributeId) {
                return this.products.find(function(product) {
                    return product.selectedVariation.id === attributeId;
                });
            };

            Order.prototype.removeProduct = function () {
                var self;

                var indexInOrder = function (product) {
                    var i = -1,
                        x = 0,
                        it,
                        length = self.products.length,
                        selectedVariationId = product.selectedVariation.id;

                    for (; x < length; x++) {
                        it = self.products[x];
                        if (it.id == product.id && it.selectedVariation.id == selectedVariationId) {
                            i = x;
                            break;
                        }
                    }

                    return i;
                };

                return function (product) {
                    self = this;

                    var index = indexInOrder(product);
                    self.products.splice(index, 1);
                }
            }();

            Order.prototype.addProduct = function () {
                var self;

                var createOrderProduct = function (data) {
                    //Clone the object, because it's a different instance of the original one
                    self.products.push(new Product(data));
                };

                return function (data) {
                    self = this;

                    if (data) {
                        var product = new Product(data);


                        if (product.hasAttributesAndStock()) {
                            var x = 0,
                                actualProduct,
                                length = this.products.length,
                                inOrder,
                                selectedVariationId;

                            selectedVariationId = product.selectedVariation.id;

                            //Perhaps the new product is in the order, and the only thing to do is adding the stock
                            for (; x < length; x++) {
                                actualProduct = this.products[x];
                                if (actualProduct.id == product.id && actualProduct.selectedVariation.id == selectedVariationId) {
                                    actualProduct.selectedStock += product.selectedStock;
                                    inOrder = true;
                                    break;
                                }
                            }

                            if (!inOrder) {
                                createOrderProduct(product);
                            }
                        } else {
                            throw new Error("Product without selected attributes");
                        }
                    } else {
                        throw new Error("No product");
                    }
                }
            }();

            Order.prototype.getShippingAddress = function() {
                return this.shippingAddress;
            };

            Order.prototype.setShippingAddress = function (shippingAddress) {
                this.shippingAddress = shippingAddress;
            };

            Order.prototype.getBillingAddress = function() {
                return this.billingAddress;
            };

            Order.prototype.setBillingAddress = function(billingAddress) {
                this.billingAddress = billingAddress;
            };

            Order.prototype.getFreeShippingCharges = function (){
                return this.freeShippingCharges;
            };

            Order.prototype.setFreeShippingCharges = function (freeShippingCharges){
                this.freeShippingCharges = freeShippingCharges;
            };

            Order.prototype.getAllowsShipping = function (){
                return this.allowsShipping;
            };

            Order.prototype.setAllowsShipping = function (allowsShipping){
                if (allowsShipping !== undefined)
                    this.allowsShipping = allowsShipping;
            };

            /**
             * Set the observations
             *
             * @method setObservations
             * @param {String} observations to set
             */
            Order.prototype.setObservations = function (observations) {
                this.observations = observations;
            };

            /**
             * Return the observations
             *
             * @method getObservations
             * @return {String} Returns the observations
             */
            Order.prototype.getObservations = function () {
                return this.observations;
            };

            /**
             * Set the order id
             *
             * @method setId
             * @param {String} id
             */
            Order.prototype.setId = function (id) {
                this.id = id;
            };

            /**
             * Return the order id
             *
             * @method getId
             * @return {String} Returns the order id
             */
            Order.prototype.getId = function () {
                return this.id;
            };

            /**
             * Set the price
             *
             * @method setPrice
             * @param {int} price
             */
            Order.prototype.setPrice = function (price) {
                this.price = price;
            };

            /**
             * Return the price
             *
             * @method getPrice
             * @return {int} Returns the price
             */
            Order.prototype.getPrice = function () {
                return this.price;
            };

            /**
             * Set an array of unavailable products
             *  The server gives back only the id of each unavailable product, but the page needs all the info of each product, that is stored in memory, so it's searched and returned.
             *
             * @method setUnavailable
             * @param {Array} unavailableProducts
             */
            Order.prototype.setUnavailable = function (unavailableProducts) {
                this.unavailable = unavailableProducts.map(function(id) {
                    return this.findProductByAttributeId(id) || this.findProductById(id);
                }.bind(this));
            };

            /**
             * Return an array of unavailable products
             *
             * @method getUnavailable
             * @return {Array} Returns if the array of unavailable products
             */
            Order.prototype.getUnavailable = function () {
                return this.unavailable;
            };

            /**
             * Return the products of the order
             *
             * @method getProducts
             * @return {Array} Returns the products
             */
            Order.prototype.getProducts = function () {
                return this.products;
            };
            /**
             * Return the current currency of the order
             *
             * @method getCurrency
             * @return {Object} Returns the currency
             */
            Order.prototype.getCurrency = function () {
                return this.currency;
            };

            /**
             * Set the id of shipping charges
             *
             * @method setShippingCharges
             * @param {Number} shippingCharges id of shipping charges selected
             */
            Order.prototype.setShippingCharges = function (shippingCharges) {
                this.shippingCharges = shippingCharges;
            };

            /**
             * return the id of shipping charges
             *
             * @method setShippingCharges
             * @param {Number} shippingCharges id of shipping charges selected
             */
            Order.prototype.getShippingCharges = function () {
                return this.shippingCharges;
            };

            /**
             * Return if paypal payment is enabled
             *
             * @method getPaypal
             * @returns {boolean|*}
             */
            Order.prototype.getPayPal = function () {
                return this.payPal;
            };

            /**
             * Set if paypal payment is enabled
             *
             * @method setPaypal
             * @param {Boolean} payPal Paypal availability
             */
            Order.prototype.setPayPal = function (payPal) {
                this.payPal = payPal;
            };

            /**
             * Set if Redsys payment is enabled
             *
             * @method setRedsys
             * @param {Boolean} redsys Redsys availability
             */
            Order.prototype.setRedsys = function (redsys) {
                this.redsys = redsys;
            };

            /**
             * Return if Redsys payment is enabled
             *
             * @method getRedsys
             * @returns {boolean|*}
             */
            Order.prototype.getRedsys = function () {
                return this.redsys;
            };

            /**
             * Set PickAtStore payment is enabled
             *
             * @method setPickAtStore
             * @param {boolean} pickAtStore PickAtStore availability
             */
            Order.prototype.setPickAtStore = function (pickAtStore) {
                this.pickAtStore = pickAtStore;
            };

            /**
             * Return PickAtStore payment is enabled
             *
             * @method getPickAtStore
             * @returns {boolean|*}
             */
            Order.prototype.getPickAtStore = function () {
                return this.pickAtStore;
            };


            /**
             * Sets minimum order amount
             *
             * @param minimumOrder
             */
            Order.prototype.setMinimumOrder = function (minimumOrder) {
                this.minimumOrder = minimumOrder;
            };

            /**
             * Return MinimumOrder amount
             *
             * @method getMinimumOrder
             * @returns {double|*}
             */
            Order.prototype.getMinimumOrder = function () {
                return this.minimumOrder;
            };

            /** Set PickAtStore option
            *
            * @method setPickAtStore
            * @param {String} pickAtStore PickAtStore
            */
            Order.prototype.setPickAtStoreOption = function (pickAtStoreOption) {
                this.pickAtStoreOption = pickAtStoreOption;
            };

            /**
             * Return PickAtStoreOption
             *
             * @method getPickAtStore
             * @returns {String|*}
             */
            Order.prototype.getPickAtStoreOption = function () {
                return this.pickAtStoreOption;
            };


            /**
             * Return if refund payment is enabled
             *
             * @method getRefund
             * @returns {boolean|*}
             */
            Order.prototype.getRefund = function () {
                return this.refund;
            };

            /**
             * Set if refund payment is enabled
             *
             * @method setRefund
             * @param {Boolean} refund Refund availability
             */
            Order.prototype.setRefund = function (refund) {
                this.refund = refund;
            };

            /**
             * Return if wire transfer payment is enabled
             *
             * @method getWireTransfer
             * @returns {boolean|*}
             */
            Order.prototype.getWireTransfer = function () {
                return this.wireTransfer;
            };

            /**
             * Set if wire transfer payment is enabled
             *
             * @method setWireTransfer
             * @param {Boolean} wireTransfer Wire transfer availability
             */
            Order.prototype.setWireTransfer = function (wireTransfer) {
                this.wireTransfer = wireTransfer;
            };

            /**
             * Return the payment model
             *
             * @method getPaymentModel
             * @returns {boolean|*}
             */
            Order.prototype.getPaymentModel = function () {
                return this.paymentModel;
            };

            /**
             * Set the payment model
             *
             * @method setPaymentModel
             * @param {Number} paymentModel Payment model
             */
            Order.prototype.setPaymentModel = function (paymentModel) {
                this.paymentModel = paymentModel;
            };

            return Order;
        }]);

})(upp);



// WEBPACK FOOTER //
// ./src/app/modules/cart/factories/cart-order-factory.js